import React, { Component } from 'react';

import { GoogleCharts } from 'google-charts'

import Dygraph from 'dygraphs'

import { generalPlot, generalPlotGrowthRate, projectGeneralPlot } from 'covid-web/totaleCasi'
import { testsPlot } from 'covid-web/tamponi'
import { init as initProvinces } from 'covid-web/provinces'

import * as _ from 'lodash'
import { Grid, Typography, Tabs, Tab, Box } from '@material-ui/core'

import PropTypes from 'prop-types';
import { smallYBounds, max2, average } from 'covid-web/analyze';
import * as moment from 'moment'
import {dateString_} from 'dygraphs/src/dygraph-utils'

const globalState = {}


const exponentialGrowthComment = (
    <Typography component="p">
      Dettagli sui calcoli: il growth rate in data t e' stimato usando la formula: <br></br> r(t) = (I(t)-I(t-1)) / (I(t-1)-I(t-2)) = v(t) / v(t-1)
      <br></br>
      dove I(t) e' il numero totale dei casi al tempo t, v(t) e' la velocita' al tempo t.
      Per una motivazione dell'uso di tale formula, vedi <a href="http://katolaz.net/covid-2019/growth.html">Epidemic 101</a>
      <br></br>
      Da tale stima, la formula per il calcolo del numero di casi al tempo t e': <img src="/eq_growth.svg" style={{ height: "50%", width: "auto" }} alt="I(t)=r**t*I(0)"></img>, dove I(0) e' il numero di infetti iniziali. 
      <br></br> 
      Nota: questa formula e' una forte semplificazione del reale fenomeno dell'epidemia corona virus,
      ma essendo l'epidemia di carattere esponenziale, rende comunque una idea di come l'epidemia potrebbe
      evolvere senza misure di contenimento, di lock-down e vaccinazione.
      <br></br>
      Gli scienziati stanno ancora studiando le dinamiche dell'epidemia Coronavirus. Tuttavia, un growth rate maggiore di uno implica un altissimo valore di crescita. Per approfondire sull'exponential growth rate vedi
      {' '}<a href="http://katolaz.net/covid-2019/growth.html">Epidemic 101</a>, 
      {' '}<a href="https://www.youtube.com/watch?v=Kas0tIxDvrg&t=81s">3Blue1Brown Youtube</a>, 
      {' '}<a href="https://en.wikipedia.org/wiki/Basic_reproduction_number">R0 (wikipedia)</a>, 
      {' '}<a href="https://www.ncbi.nlm.nih.gov/pubmed/32007643">Zhao, Lin, et al.</a>
      {' '}("The early outbreak data largely follows the exponential growth. [We estimated a] mean R0 from 2.24 to 3.58").
      <br></br>
      Ci sono formule e modelli molto piu' rifiniti, precisi e validi, che tengono conto
      delle diverse possibili fasi ed evoluzioni della malattia nel singolo individuo,
      tuttavia la dinamica di base dell'exponential growth e' la stessa.
    </Typography>
)

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (

    <Typography
      component="div"
      role="tabpanel"
      hidden={!value || value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{height:'100%'}}
    >
      {value === index && <Box style={{height:'50%'}} p={3}>{children}</Box>}
    </Typography>

  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

// returns only the portion of the plot with dates >= startDate.
// data: plot in GViZ format 
function filterByStartDate(startDate: Date, data: any[][]) {
    const startIdx = data.findIndex((r,i) => i > 0 && r[0].getTime() >= startDate.getTime())
    if (startIdx >= 0)
        return [data[0]].concat(data.slice(startIdx))
    else
        return data
}


class PlotComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date().toLocaleString(),
      projPlotStart: null,
      activeStep: 0,
      value: 1,
      open: false,
      startDate: moment().subtract(1, 'month').toDate()
    }
  }

  getSelectedItems() {
      
      if (this.props.types == "Nazione")
          return ["Italia"]

      if (this.props.field === "denominazione_regione")
          return this.props.regionValues
      else 
          return this.props.provinceValues

  }

  componentWillMount() {
    GoogleCharts.load(() => {
      this._draw(this.props.field, this.getSelectedItems())
    });
  }

  onOrientationChange(ev) {

    // After orientationchange, add a one-time resize event: https://stackoverflow.com/a/49383279/7092558
    var afterOrientationChange = () => {

        this.setState({innerWidth: window.innerWidth})

        // Remove the resize event listener after it has executed
        window.removeEventListener('resize', afterOrientationChange);
    };
    window.addEventListener('resize', afterOrientationChange);
  }

  componentDidMount() {
      const orHandler = this.onOrientationChange.bind(this)
      window.addEventListener("orientationchange", orHandler)
      this.setState({ onOrientationChange: orHandler })
  }

  componentWillUnmount() {
      if (this.state.onOrientationChange)
          window.removeEventListener("orientationchange", this.state.onOrientationChange)
  }

  componentDidUpdate(prevProps, prevState) {


    if (prevState.startDate != this.state.startDate ||
        prevProps.types !== this.props.types ||
        prevProps.field !== this.props.field ||
      !_.isEqual(prevProps.regionValues, this.props.regionValues) ||
      !_.isEqual(prevProps.provinceValues, this.props.provinceValues)
    ) {

      const selectedItems = this.getSelectedItems()
      if (!selectedItems.length) return;

      this._draw(this.props.field, selectedItems)

    } else if (prevState.innerWidth != this.state.innerWidth) {
      // resize all
      for (const field of Object.keys(globalState)) {
        const value = globalState[field]
        if (_.isObject(value) && 'resize' in value && _.isFunction(value.resize)) {
          value.resize()
        }
      }
    }

  }

  // Darken a color
  darkenColor(colorStr) {
    // Defined in dygraph-utils.js
    var color = Dygraph.toRGB_(colorStr);
    color.r = Math.floor((255 + color.r) / 2);
    color.g = Math.floor((255 + color.g) / 2);
    color.b = Math.floor((255 + color.b) / 2);
    return 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')';
  }

  // This function draws bars for a single series. See
  // multiColumnBarPlotter below for a plotter which can draw multi-series
  // bar charts.
  barChartPlotter(e) {
    var ctx = e.drawingContext;
    var points = e.points;
    var y_bottom = e.dygraph.toDomYCoord(0);

    ctx.fillStyle = this.darkenColor(e.color);

    // Find the minimum separation between x-values.
    // This determines the bar width.
    var min_sep = Infinity;
    for (var i = 1; i < points.length; i++) {
      var sep = points[i].canvasx - points[i - 1].canvasx;
      if (sep < min_sep) min_sep = sep;
    }
    var bar_width = Math.floor(2.0 / 3 * min_sep);

    // Do the actual plotting.
    for (var j = 0; j < points.length; j++) {
      var p = points[j];
      var center_x = p.canvasx;

      ctx.fillRect(center_x - bar_width / 2, p.canvasy,
        bar_width, y_bottom - p.canvasy);

      ctx.strokeRect(center_x - bar_width / 2, p.canvasy,
        bar_width, y_bottom - p.canvasy);
    }
  }


  legendFormatter(data) {
    const g = data.dygraph
    const labels = g ? g.getLabels() : []
    if (data.x === null) {
      // This happens when there's no selection and {legend: 'always'} is set.
      return data.series
                  .map(series => 
                          '<div>' + series.dashHTML + '</div>' +
                          '<div>' + series.labelHTML + '</div>'
                        )

    }
    const nowZeroSec = new Date(); nowZeroSec.setSeconds(0); nowZeroSec.setMilliseconds(0);
    var html = '<div>' + ( 
            this.getLabels()[0] + ': ' + (data.xHTML || dateString_(nowZeroSec))
    )  + '</div>' ;
    data.series.forEach((series, i) => {
      if (!series.isVisible) return;
      var labeledData = series.labelHTML  + (series.yHTML ? ': ' + series.yHTML + "&nbsp;" : ': ------');
      if (series.isHighlighted) {
        labeledData = '<b>' + labeledData + '</b>';
      }
      var strokePattern = i>0 && g ? g.getOption('strokePattern', labels[i+1]) : [];
      const border = 
            (!strokePattern || strokePattern.length <= 1 ? "solid " : "dashed ") +
           (series.color || "white") +
           " 3px"
      html += `<div style="border-bottom: ${border}">` +labeledData+ '</div>';
    });

    return html;
  }

  async drawGrowthRate(field, selectedItems, render = true) {


    await initProvinces();

    const grPlot = await generalPlotGrowthRate(field, selectedItems)
    grPlot.data = filterByStartDate(this.state.startDate, grPlot.data)

    globalState.drawGrowthRatePlot = grPlot

    const yBounds = smallYBounds(grPlot.data.slice(1), 5)

    const lastDate = grPlot.data[grPlot.data.length - 1][0] // convert the last date to string
    const lastGrowthRates = grPlot.data[0].map((column, i) => {
      return [column.label]
        .concat([grPlot.data[grPlot.data.length - 1][i]]) // take the growth rate of column i
    }).slice(1, grPlot.data[0].length - 1) // note: length-1 is for removing "crescita zero" column
    this.setState({
      lastGrowthRates: {
        data: lastGrowthRates,
        date: lastDate
      }
    })

    grPlot.gviz = GoogleCharts.api.visualization.arrayToDataTable(grPlot.data);

    const options = {
      legendFormatter: this.legendFormatter,
      // labelsSeparateLines: true,
      strokeWidth: 3,
      legend: 'always',
      labelsDiv: 'growthRateLegendDiv',
      colorValue: 1,
      digitsAfterDecimal: 4,
      series: grPlot.options,
      valueRange: yBounds
    }

    if (render) {
      globalState.drawGrowthRateGraph = new Dygraph(
        document.getElementById("growthRatePlotDiv"),
        grPlot.gviz,
        options
      )
      globalState.drawGrowthRateGraph.resize()
    }


  }

  annotationOnHighlight(g, ev, x, points, row, seriesName) {
    const ann = []

    for (const p of points) {
      const ystr = '' + p.yval
      const datestr = moment(x).format("DD MMM")
      const maxlength = Math.max(ystr.length, datestr.length)
      const text = `${ystr}<br>${datestr}`
      const length = maxlength / 1.5
      const lines = 2
      ann.push({
        series: p.name,
        xval: x,
        width: 18 * length,
        height: 23 * lines,
        tickHeight: 4,
        html: text
      })
    }

    g.setAnnotations(ann)
  }

  annotationOnPointClick(g, ev, point) {
    return this.annotationOnHighlight(g, ev, point.xval, [point])
  }

  async drawChart(field, selectedItems, render = true) {

    function onlyVelocity(data: any[][]) {
    
        return data.map((r,i) =>
            r.filter((c,i) => i % 2 == 0))

    }

    function onlyTotaleCasi(data: any[][]) {
    
        return data.map((r,i) =>
                    r.filter((c,i) => i == 0 || i % 2 == 1))

    }

    await initProvinces(); // C: no sense. A: just common sense :)

    const plot = await generalPlot(field, selectedItems)
    plot.data = filterByStartDate(this.state.startDate, plot.data)

    globalState.drawChartPlot = plot

    const plotTotale = Object.assign({}, plot)
    plotTotale.data = onlyTotaleCasi(plot.data)
    plotTotale.gviz = GoogleCharts.api.visualization.arrayToDataTable(plotTotale.data);
    const totaleOptions = {
      legendFormatter: this.legendFormatter,
      // labelsSeparateLines: true,
      strokeWidth: 3,
      legend: 'always',
      labelsDiv: 'totaleLegendDiv',
      colorValue: 1,
      series: Object.assign({}, plotTotale.options),
    }

    const plotVel = Object.assign({}, plot)
    plotVel.data = onlyVelocity(plot.data)
    plotVel.gviz = GoogleCharts.api.visualization.arrayToDataTable(plotVel.data);
    const velOptions = {
      legendFormatter: this.legendFormatter,
      // labelsSeparateLines: true,
      strokeWidth: 3,
      legend: 'always',
      labelsDiv: 'velLegendDiv',
      colorValue: 1,
      series: Object.assign({}, plotVel.options),
    }

    if (render) {
      if (globalState.drawChartGraphVel)
        globalState.drawChartGraphVel.destroy()

      globalState.drawChartGraphVel = new Dygraph(
        document.getElementById("velPlotDiv"),
        plotVel.gviz,
        velOptions
      )
      globalState.drawChartGraphVel.ready(()=>{
        globalState.drawChartGraphVel.resize()
      })

      if (globalState.drawChartGraphTotale)
        globalState.drawChartGraphTotale.destroy()

      globalState.drawChartGraphTotale = new Dygraph(
        document.getElementById("totalePlotDiv"),
        plotTotale.gviz,
        totaleOptions
      )
      globalState.drawChartGraphTotale.ready(()=>{
        globalState.drawChartGraphTotale.resize()
      })

        /* does not work when zooming
      const g = globalState.drawChartGraph
      g.ready(() => {
        g.updateOptions({
          pointClickRadius: 50,
          pointClickCallback: this.annotationOnPointClick.bind(this, g)
        })
      })
      */
    }

  }

  /*
async drawR0(field, selectedItems, render = true) {

  await initProvinces();

  const plot = await plotR0(field, selectedItems)
  globalState.drawR0Plot = plot

  plot.gviz = GoogleCharts.api.visualization.arrayToDataTable(plot.data);

  const options = {
    legendFormatter: this.legendFormatter,
    // labelsSeparateLines: true,
    strokeWidth: 3,
    legend: 'always',
    labelsDiv: 'r0LegendDiv',
    colorValue: 1,
    series: plot.options
  }

  if (render) {
    globalState.drawR0Graph = new Dygraph(
      document.getElementById("r0PlotDiv"),
      plot.gviz,
      options
    )
  }

}
*/

  async calculateProjectionChart(field, selectedItems, startDate = null) {

    await initProvinces()

    const plot = await projectGeneralPlot(field, selectedItems, startDate)

    this.setState({
      projPlotStart: {
        gr: plot.gr,
        date: plot.startDate,
        series: plot.series 
      }
    })

    plot.gviz = GoogleCharts.api.visualization.arrayToDataTable(plot.data);

    return {plot, safeMax: plot.safeMax}
  }

  /* Important: this function must be AFTER drawChart() and drawGrowthRateChart() */
  async drawProjectionChart(field, selectedItems, startDate = null) {

    const {plot, safeMax} = await this.calculateProjectionChart(field, selectedItems, startDate)
    globalState.projectionPlot = plot

    const options = {
      legendFormatter: this.legendFormatter,
      // labelsSeparateLines: true,
      strokeWidth: 3,
      legend: 'always',
      labelsDiv: 'projLegendDiv',
      colorValue: 1,
      series: plot.options,
      valueRange: [0, safeMax],
    }

    if (globalState.drawProjectionChartGraph)
      globalState.drawProjectionChartGraph.destroy()

    globalState.drawProjectionChartGraph = new Dygraph(
      document.getElementById("projPlotDiv"),
      plot.gviz,
      options
    )
    globalState.drawProjectionChartGraph.resize()

    const g = globalState.drawProjectionChartGraph
    g.ready(() => {
          g.updateOptions({ 
              pointClickRadius: 50,
              pointClickCallback: async (ev, point) => {
                const i = point.idx
                const data = globalState.projectionPlot.data
                let startDate = data[i+1][0]
                if (startDate.getTime() > globalState.projectionPlot.maxDate.getTime()) {
                    startDate = globalState.projectionPlot.maxDate
                }
                const {plot, safeMax} = await this.calculateProjectionChart(field, selectedItems, startDate)
                g.updateOptions({ 
                    file: plot.gviz,
                    valueRange: [0, safeMax]
                })
              }
          })
    })


  }

  async drawTamponiChart(field, selectedItems) {

    //await initProvinces()
    //await initRegions() done internally by testsPlot()

    const plotT = await testsPlot(field, selectedItems, 0)
    plotT.data = filterByStartDate(this.state.startDate, plotT.data)

    const plotP = _.cloneDeep(plotT)

    this.setState({ firstCasiTestati: plotT.firstCasiTestatiMap })

    for (let i = 1; i < plotT.data.length; i++) {
      for (let j = 1; 2 * j < plotT.data[i].length; j++) {
        plotT.data[i][2 * j] = null
        plotP.data[i][2 * (j - 1) + 1] = null
      }
    }

    const yPBounds = smallYBounds(plotP.data.slice(1), 1)

    plotT.gviz = GoogleCharts.api.visualization.arrayToDataTable(plotT.data);

    plotP.gviz = GoogleCharts.api.visualization.arrayToDataTable(plotP.data);

    const optionsT = {
      legendFormatter: this.legendFormatter,
      // labelsSeparateLines: true,
      strokeWidth: 3,
      legend: 'always',
      labelsDiv: 'tampTLegendDiv',
      colorValue: 1,
      series: plotT.options,
    }

    globalState.drawTampTChartGraph = new Dygraph(
      document.getElementById("tampTPlotDiv"),
      plotT.gviz,
      optionsT
    )
    globalState.drawTampTChartGraph.resize()

    const optionsP = _.clone(optionsT)
    optionsP.labelsDiv = 'tampPLegendDiv'
    optionsP.series = _.clone(optionsT.series)
    optionsP.valueRange = [0, Math.min(100, yPBounds[1])]

    globalState.drawTampPChartGraph = new Dygraph(
      document.getElementById("tampPPlotDiv"),
      plotP.gviz,
      optionsP
    )
    globalState.drawTampPChartGraph.resize()

  }

  async  _draw(field, selectedItems) {
    switch (this.state.value) {
      case 1:
        await this.drawChart(field, selectedItems);
        break;

      case 2:
        await this.drawTamponiChart(field, selectedItems)
        break

      case 3:
        await this.drawGrowthRate(field, selectedItems);
        break;

      case 4:
        await this.drawProjectionChart(field, selectedItems)
        break;

      default:
        break
    }
  }

  /* does not work with pinch-zoom
  zoomVelocity() {

    if (!globalState.drawChartGraph || !globalState.drawChartPlot)
        return

    const recentDateWindow = [moment().subtract(30, 'days').toDate(), new Date()]

    const velocityPlots = globalState.drawChartPlot.data
        .map((r,i) => i == 0 ? 
                r : 
                r.map((c,i) =>
                    i == 0 || i % 2 == 0 ? 
                        c : 
                        'not-vel')
                 .filter(c => c != 'not-vel'))
        .filter((r,i) => i == 0 || r[0].getTime() >= recentDateWindow[0].getTime())
                

    const yBounds = smallYBounds(velocityPlots.slice(1), 5)

    console.log(yBounds)

    globalState.drawChartGraph.updateOptions({
        valueRange: [0, yBounds[1]],
        dateWindow: recentDateWindow
    })
  }*/

  handleChange(event, value) {
    if (value == 0) {
        this.props.handleDrawerToggle()
        return
    }
    const { field } = this.props;
    const selectedItems = this.getSelectedItems(); 
    this.setState({ value: value }, () => {
      this._draw(field, selectedItems)
    })
  }

  getLabel() {
    const { value } = this.state;
    switch (value) {
      default: return 'Approfondimento'
    }
  }

  getContent(key: string) {

    const {  
        lastGrowthRates, value, projPlotStart, firstCasiTestati, startDate
    } = this.state;

    const lastMonth = moment().subtract(1, 'month').toDate();

    const clickToChangeStartDate = (
        !startDate || startDate.getTime() > 0 ?
         (<Typography component="p">
              <button onClick={() => this.setState({ startDate: new Date(0) }) }
              >Clicca per vedere anche i dati prima del {startDate.toLocaleString()}</button>
        </Typography>) :
        (<Typography component="p">
              <button onClick={() => this.setState({ startDate: lastMonth }) }
              >Clicca per vedere i dati solo a partire dal {lastMonth.toLocaleString()}</button>
        </Typography>)
    );

    const lastGrowthRate = lastGrowthRates

    const firstCasiTestatiDate = firstCasiTestati && new Date(Math.max(...firstCasiTestati.values()))
    const firstCasiTestatiDateStr = firstCasiTestatiDate ? firstCasiTestatiDate.toLocaleString() : '[non disponibile]'

    const tamponiExplanation = (
      <div className="explanation">
        <Typography component="p">
          <br></br>
          In questi due grafi viene rappresentata la percentuale di tamponi risultati positivi
          e il numero totale di tamponi effettuati in un dato giorno.
          <br></br>
          Facendo un esempio estremo, se il numero di tamponi e' basso, 10, e il numero di casi in quel giorno e' 10 (e la percentuale e' 100%), e' comunque possibile che ci siano, in realta', molti piu' casi, ad esempio, 100. Semplicemente, gli altri 90 casi non sono stati registrati perche' non sono stati fatti i tamponi.
          Quindi, possiamo dire che piu' il numero di tamponi e' alto e piu' la percentuale e' bassa, piu' il numero totale dei casi e i numeri derivati da esso (velocita', growth rate), mostrati negli altri grafi, sono indicativi.
          <br></br>
          {clickToChangeStartDate}
          <br></br>
          Dettagli: a partire da giorno {firstCasiTestatiDateStr}, il numero dei tamponi e' sostituito dal numero 
          di "casi testati". Questo perche' i tamponi vengono fatti piu' volte ad una stessa persona. 
          "Casi testati", invece, non conta i tamponi duplicati, quindi una persona viene conteggiata una volta sola.
          <br></br>
          Prima di giorno {firstCasiTestatiDateStr}, questo parametro non era disponibile. Per piu' informazioni,
          vedi  <a href="https://www.youtrend.it/2020/03/25/coronavirus-il-rebus-dei-tamponi-multipli/">Lorenzo Ruffino</a>.
          <br></br>
          Nota: non e' disponibile il numero di tamponi per provincia, ma solo per regione.
          <br></br>
          Nota: nei primi giorni di cambio da "tamponi" a "casi testati", ci sono state delle irregolarita' nei dati di Lombardia, Lazio e Campania. Piu' precisamente, giorno 20 e 21 aprile, vedi <a href="https://github.com/pcm-dpc/COVID-19/blob/master/note/dpc-covid19-ita-note-it.csv">Note DPC</a>.
         </Typography>
      </div>
    )

    const contentBody = () => {
        switch (value) {
               
          case 1:
                return (
              <div className="explanation">
                <br></br>
                  {key == "totalePlotDiv" ? 
                    <Typography component="p">
                      Totale casi: sono tutte le persone che sono state certificate essere infette da coronavirus. Questo numero e' uguale alla somma "persone attualmente positive" + "persone guarite" + "persone decedute"
                    </Typography> :
                    <Typography component="p">
                      Velocita': e' il numero dei nuovi casi. Se, ad esempio, oggi la velocita' e' 10, vuol dire ci sono stati 10 casi in piu' rispetto a ieri. Lo stesso vale per gli altri giorni: se giorno 15 Marzo la velocita' e' 7, vuol dire che rispetto al giorno precedente ci sono stati 7 casi in piu'.
                    </Typography>
                  }
                <br></br>
                {clickToChangeStartDate}
              </div>
            )

          case 2: return tamponiExplanation;

          case 3: return (
            <div className="explanation">
              <Typography component="p">
                In data {lastGrowthRate?.date ? lastGrowthRate?.date.toLocaleString() : '[non-disponibile]'}, i growth rate sono:
                          <br></br>
                <br></br>
                {
                  lastGrowthRate?.data ?
                    lastGrowthRate.data.map((d, i) =>
                      <span key={i}>{d
                        .map(n => _.isNumber(n) ? n.toFixed(4) : n)
                        .join(' ')
                      }
                        <br></br></span>) :
                    '[non disponibile]'
                }
              </Typography>

              <br></br>
              <Typography component="p">
                Growth rate: rapporto tra la velocita' di un giorno e quella del giorno precedente. E' una quantita' importante perche' e' una stima della crescita della velocita'. Se il growth rate e' maggiore di 1, allora la velocita' sta' crescendo. Se e' minore, sta' diminuendo. L'epidemia finisce solo se la velocita' scende e rimane a zero.
                </Typography>
              <br></br>
              {clickToChangeStartDate}
              <br></br>
              <Typography component="p">
                La crescita del numero di casi in un'epidemia come il Coronavirus e' esponenziale.
                In una crescita esponenziale anche valori poco piu' alti (growth rate > 1) implicano un'altissima crescita.
                Ad esempio, se ci sono 100 infetti, con growth rate 1.22, solo dopo 30 giorni ci saranno 39000 infetti.
              </Typography>
              <br></br>
              {exponentialGrowthComment}
            </div>
          );

          case 4: return (
              <div className="explanation">
                <Typography component="p">
                  In questo grafo, viene usato il growth rate per mostrare <b>a grandi linee</b>{' '}
                  come procederebbe l'epidemia se non venissero fatte delle misure di contenimento e lock-down.
                  Senza misure di prevenzione, l'andamento dei nuovi casi sarebbe esponenziale.
                </Typography>
                {projPlotStart ? (
                    <Typography component="p">
                        L'andamento ipotetico graficato (linee tratteggiate) e' a partire da giorno {projPlotStart.date.toLocaleString()},
                        dove i growth rate erano {projPlotStart.gr.map(r=>r.toFixed(3)).join(', ')} in {projPlotStart.series.join(', ')}.
                        <br></br>
                        Puoi cliccare su un punto del grafo per cambiare il giorno dell'inizio della proiezione. La proiezione verra' ricalcolata a partire da quel punto, usando il growth rate di quel giorno.
                         <br></br>
                         Nota: la proiezione inizia giorno {projPlotStart.date.toLocaleString()}. Il numero di infetti iniziale <i>I(0)</i> in quel giorno e' scelto come il numero di "totale positivi", ovvero il numero di persone infette vive e non ancora guarite. Nel grafo si puo' notare un balzo in basso, infatti, "totale positivi" {'<='} "totale casi".                         <br></br>
                         Infine, se il growth rate e' minore di 1, la proiezione non ha piu' senso e verra' graficata una linea costante.
                    </Typography>
                    ) :
                    ''}
              {exponentialGrowthComment}
              </div>
            )

          default: return <div />
        }
    }

    const isFinalContent = !key || key == "velPlotDiv"

    return (
        <>
            {contentBody()}
            {isFinalContent ? 
                (<div style={{"font-size": "smaller"}}>
                <br></br>
		Nota (Feb 2024): i dati sono stati congelati fino al dicembre del 2020. Il sito infatti non e' piu' attivamente sviluppato.<br></br>
                I dati sono forniti dalla <a href="https://github.com/pcm-dpc/COVID-19">Protezione Civile</a>.
                Il codice sorgente dei plot e' disponibile su <a href="https://github.com/numericnews/numericnews.github.io/tree/master/covid-web">github</a>.
                <br></br>
                <a href="https://www.linkedin.com/in/lopumo/">Andrea Lo Pumo</a>, <a href="https://www.linkedin.com/in/claudiomusumeci/">Claudio F. Musumeci</a>.  <a href="mailto:numeric-news-authors@googlegroups.com">Contattaci</a>.
                </div>) :
                <></>
            }
        </>
    )
  }


  handleClose() {
    this.setState({ open: false });
  }

  render() {

    const maxWidth = window.innerWidth > window.innerHeight ?
                        (window.innerWidth - 20/100*window.innerWidth) + 'px' :
                        (window.innerWidth - 10/100*window.innerWidth) + 'px'
/*
    const maxHeight = window.innerHeight > window.innerWidth ?
                        (window.innerHeight - 10/100*window.innerHeight) + 'px' :
                        (window.innerHeight - 5/100*window.innerHeight) + 'px'
*/
    const { value } = this.state;

    const provRegs = this.props.types == "Regione" ? 'regioni' : 'province'

    const doubleClickZoomHint = (
        <div style={{left:'60px', top:'10px', position: 'absolute', "font-size": 'small'}}>
                Due dita per zoomare. Doppio click per resettare.
        </div>
    )

    const getTabBar = () => document.getElementById('tabBar')

    return (


      <React.Fragment>
        <Tabs id="tabBar"
            onChange={this.handleChange.bind(this)} aria-label="ploty tabs" 
                  variant="fullWidth"
                  scrollButtons="auto"
                  className='generalTabs'
                  value={this.state.value}
      >
          <Tab label={"Altre "+provRegs}/>
          <Tab label="Totale casi" />
          <Tab label="Tamponi" />
          <Tab label="Growth Rate" />
          <Tab label="Exp Growth Rate" />
        </Tabs>
        <TabPanel label={"Altre "+provRegs} value={value} index={0} >
        empty
        </TabPanel>
        <TabPanel label={"Totale casi"} value={value} index={1} >
          <div id="totaleCasi" style={{height:'100%', top: getTabBar()?.clientHeight, position: 'relative'}}>
          <Grid container style={{height:(window.innerHeight*75/100)+'px'
          }}>
            <Grid item xs={12} md={12} className="containerLegend">
              <div id='totaleLegendDiv'></div>
              </Grid>

              <Grid item xs={12} md={12} style={{
                  position: 'relative',
                  width: '90%',
                  height: '100%',
                  maxWidth,
                 }}>
                {doubleClickZoomHint}
                <div id='totalePlotDiv' style={{ width: '100%',height:'100%' }}></div>
              </Grid>
              <Grid item xs={12}>
           {this.getContent("totalePlotDiv")}       
           </Grid>
            <Grid item xs={12} md={12} className="containerLegend">
              <div id='velLegendDiv'></div>
              </Grid>

              <Grid item xs={12} md={12} style={{
                  position: 'relative',
                  width: '90%',
                  height: '100%',
                  maxWidth,
                 }}>
                {doubleClickZoomHint}
                <div id='velPlotDiv' style={{ width: '100%',height:'100%' }}></div>
              </Grid>
              <Grid item xs={12}>
           {this.getContent("velPlotDiv")}       
           </Grid>

            </Grid>
          </div>
        </TabPanel>
        <TabPanel label={"Tamponi"} value={value} index={2}>
          <div style={{top: getTabBar()?.clientHeight, position: 'relative'}}>
            <Grid container style={{ height: window.innerHeight * 75 / 100 + 'px' }}>
              <Grid item xs={12} md={12} className="containerLegend">
                <div id='tampPLegendDiv'></div>
              </Grid>
              <Grid item xs={12} md={12} style={{ position: 'relative', width: '100%', height: '100%', maxWidth }}>
                {doubleClickZoomHint}
                <div id='tampPPlotDiv' style={{ width: '100%', height: '100%' }}></div>
              </Grid>



              <Grid item xs={12} md={12} style={{ position: 'relative', width: '100%', height: '100%', maxWidth }}>
                {doubleClickZoomHint}
                <div id='tampTPlotDiv' style={{ width: '100%', height: '100%' }}></div>
              </Grid>
              <Grid item xs={12} md={12} className="containerLegend">
                <div id='tampTLegendDiv'></div>
              </Grid>

              <Grid item xs={12}>
                {this.getContent()}
              </Grid>
            </Grid>
          </div>

        </TabPanel>

        <TabPanel label={"Growth Rate"} value={value} index={3}>
          <div style={{top: getTabBar()?.clientHeight, position: 'relative'}}>
          <Grid container style={{height:window.innerHeight*75/100+'px'}}>
               <Grid item xs={12} md={12} className="containerLegend">
                  <div id='growthRateLegendDiv'></div>
               </Grid>
               <Grid item xs={12} md={12} style={{ position: 'relative', width: '100%',height:'100%',maxWidth}}>
                  {doubleClickZoomHint}
                  <div id='growthRatePlotDiv' style={{ width: '100%',height:'100%'  }}></div>
               </Grid>
               <Grid item xs={12}>
                 {this.getContent()}       
               </Grid>
            </Grid>
          </div>
        </TabPanel>

        <TabPanel label={"Proiezione"} value={value} index={4}>
          <div style={{top: getTabBar()?.clientHeight, position: 'relative'}}>
              <Grid container style={{height:window.innerHeight*75/100+'px'}}>
                  <Grid item xs={12} md={12} className="containerLegend">
                      <div id='projLegendDiv'></div>
                  </Grid>
                  <Grid item xs={12} md={12} style={{ position: 'relative', width: '100%',height:'100%',maxWidth}}>
                      {doubleClickZoomHint}
                      <div id='projPlotDiv' style={{ width: '100%',height:'100%'  }}></div>
                  </Grid>
                  <Grid item xs={12}>
                      {this.getContent()}       
                  </Grid>
              </Grid>
          </div>

        </TabPanel>
      </React.Fragment>
    );
  }
}
export default PlotComponent;
